import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Nomination from './Nomination'
import Modal from '../../2_Molecules/Modal/Modal'

const NominationModal = ({
  formExtraParams
}) => {
  const { formImage, isPopUp, ...restParams } = formExtraParams;
  const isPopUpBoolean = (isPopUp && isPopUp.toLowerCase() === 'true');
  const modalRef = useRef(null);

  return (
    <Modal
      className={`mz-kmi-modal ${isPopUpBoolean ? 'mz-popup-modal' : ''}`}
      style={{ backgroundImage: formImage ? `url(${formImage})` : '' }}
      isDark={true}
      modalRef={modalRef}
    >
      <Nomination
        formExtraParams={restParams}
      />
    </Modal>
  )
}

NominationModal.propTypes = {
  formExtraParams: PropTypes.object.isRequired
}

export default NominationModal

